"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const Menu_1 = __importDefault(require("./Menu"));
const HeaderLogo_1 = __importDefault(require("./HeaderLogo"));
const constants_1 = require("../constants");
const movistarMenuNormalizers_1 = require("./movistarMenuNormalizers");
const utils_1 = require("../utils");
const ActionBottomBar_1 = __importDefault(require("./ActionBottomBar"));
const MoreOptions_1 = __importDefault(require("./MoreOptions"));
const SegmentSelector_1 = __importDefault(require("./SegmentSelector"));
/* ERROR MONITORING */
// import { actions as errorActions } from '../../reducers/error';
class MovistarMenu extends react_1.Component {
    componentDidMount() { }
    /* MOVE BELOW methods TO movistarMenuNormalizers */
    render() {
        const { segment, fullName, pageSegment, userSegment, infoContextApiFailed, isPriority, taggingInfo, } = this.props;
        let { userType } = this.props;
        if (infoContextApiFailed) {
            userType = '';
        }
        const { movistarMenuInfoEmp } = this.props;
        let { movistarMenuInfo, sectionMenu } = this.props;
        if (!sectionMenu || !movistarMenuInfo) {
            return null;
        }
        const realUserSegment = (0, utils_1.decideUserSegment)(userSegment, pageSegment);
        // si el usuario no esta logado
        if (!userType) {
            movistarMenuInfo = movistarMenuInfo.public;
            sectionMenu = sectionMenu.public;
        }
        // PARTICULARES
        // usuario particulares telco
        if (userType === constants_1.TELCO && realUserSegment === constants_1.PARTICULARES) {
            movistarMenuInfo = movistarMenuInfo.telco;
            sectionMenu = sectionMenu.telco;
        }
        // usuario particulars legado
        if (userType === constants_1.LEGADO && realUserSegment === constants_1.PARTICULARES) {
            movistarMenuInfo = movistarMenuInfo.legado;
            sectionMenu = sectionMenu.legado;
        }
        // EMPRESAS
        // usuario empresas siempre será legado
        if (userType && realUserSegment === constants_1.EMPRESAS) {
            if ((0, utils_1.checkIFPaut)(userSegment)) {
                movistarMenuInfo = Object.assign({}, movistarMenuInfoEmp.legado);
            }
            else {
                movistarMenuInfo = Object.assign({}, movistarMenuInfoEmp.telco);
            }
            // EL MENU DE PAGINA SIGUE SIENTO PARTICULARES aunque el usuario este logado como emp
            sectionMenu = sectionMenu.public;
        }
        if (!movistarMenuInfo) {
            return null;
        }
        let menu = null;
        let options = null;
        let modalProps = null;
        let actionBar = null;
        let actionBarIdSelected = 'default';
        let forcedTitleBarId = null;
        let forcedTitleBarIdLink = null;
        const type = (sectionMenu === null || sectionMenu === void 0 ? void 0 : sectionMenu.type) || 'default';
        /* desencapsulamos valores para el forzado */
        if (sectionMenu &&
            sectionMenu.forcedTitleBarId &&
            sectionMenu.forcedTitleBarIdLink) {
            ({ forcedTitleBarId, forcedTitleBarIdLink } = sectionMenu);
        }
        if (sectionMenu && sectionMenu.titleBarId) {
            actionBarIdSelected = sectionMenu.titleBarId;
        }
        ({ menu, options, actionBar } = (0, movistarMenuNormalizers_1.getMenuSections)(movistarMenuInfo.menu, userType, segment, actionBarIdSelected, userSegment));
        if (movistarMenuInfo.modalProps) {
            ({ modalProps } = movistarMenuInfo);
        }
        const cssPriority = isPriority ? ` ${constants_1.PRIORITY}` : '';
        const cssSegment = ` ${segment}`;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: `MovistarMenu${cssPriority}${cssSegment}` },
                react_1.default.createElement("div", { className: "container" },
                    react_1.default.createElement("div", { className: "MovistarMenuContainer" },
                        react_1.default.createElement("div", { className: "LogoAndMenu" },
                            movistarMenuInfo.logo && (react_1.default.createElement(HeaderLogo_1.default, { logoInfo: movistarMenuInfo.logo, segment: segment })),
                            type !== constants_1.LAYOUT_TYPES.BUY_PROCESS && (react_1.default.createElement(react_1.default.Fragment, null,
                                react_1.default.createElement(Menu_1.default, { menu: menu, segment: segment, userType: userType, taggingInfo: taggingInfo, actionBarIdSelected: actionBarIdSelected || 'default', modalProps: modalProps }),
                                !userType && (react_1.default.createElement(SegmentSelector_1.default, { segment: segment, taggingInfo: taggingInfo }))))),
                        options &&
                            options.length > 0 &&
                            type !== constants_1.LAYOUT_TYPES.BUY_PROCESS && (react_1.default.createElement(MoreOptions_1.default, { options: options, fullName: fullName, userType: userType, segment: segment, isPriority: isPriority, modalProps: modalProps, taggingInfo: taggingInfo }))))),
            actionBar &&
                actionBar.length > 0 &&
                type !== constants_1.LAYOUT_TYPES.BUY_PROCESS && (react_1.default.createElement(ActionBottomBar_1.default, { key: JSON.stringify(actionBar), menu: actionBar, segment: segment, userType: userType, userSegment: userSegment, fullName: fullName, modalProps: modalProps, taggingInfo: taggingInfo, isPriority: isPriority, actionBarIdSelected: actionBarIdSelected || 'default' }))));
    }
}
const mapStateToProps = (state) => ({
    segment: state.main.context.pageSegment,
    fullName: state.header.fullName,
    userType: state.main.context.userType,
    userSegment: state.main.context.userSegment,
    pageSegment: state.main.context.pageSegment,
    infoContextApiFailed: state.main.context.infoContextApiFailed,
    isPriority: state.main.context.userPriority,
    isBuyProcess: state.header.isBuyProcess,
    movistarMenuInfo: state.header.movistarMenuInfo,
    sectionMenu: state.header.sectionMenu,
    movistarMenuInfoEmp: state.header.movistarMenuInfoEmp,
    sectionMenuEmp: state.header.sectionMenuEmp,
});
const mapDispatchToProps = (dispatch) => ({
// handleSeveral: (errorData) => dispatch(errorActions.handleSeveral(errorData)),
});
exports.default = (0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps)(MovistarMenu);
//# sourceMappingURL=index.js.map